import LabelledDivRow from "components/LabelledDivRow";
import React from "react";

interface Props {
  azureStorage: server.dto.AzureStorageDiagnostic
  serverCdn: string
}

const CdnRows = ({ azureStorage, serverCdn }: Props) => {
  return <>
    <LabelledDivRow label="Azure Storage Cdn">
      <div style={{ overflowWrap: "anywhere" }}>{azureStorage.cdn}</div>
    </LabelledDivRow>
    <LabelledDivRow label="Server Cdn">
      <div style={{ overflowWrap: "anywhere" }}>{serverCdn}</div>
    </LabelledDivRow>
  </>;
};

export default CdnRows;